import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { RedoListItem } from "../../../../arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "../../../../arbiter-components/select-dropdown/redo-single-select-dropdown-input";

export type ChitChatsEnvironment = "production" | "staging";

export const ChitChatsCarrierInput = groupInput({
  clientId: input<string>({ validator: nonEmptyValidator }),
  apiToken: input<string>({ validator: nonEmptyValidator }),
  environment: input<ChitChatsEnvironment>(),
});

export type ChitChatsCarrierValue = InputSchema.Value<
  typeof ChitChatsCarrierInput
>;

export type ChitChatsCarrierForm = InputSchema.Input<
  typeof ChitChatsCarrierInput
>;

export const ChitChatsCarrierDefault = (): ChitChatsCarrierValue => ({
  clientId: "",
  apiToken: "",
  environment: "production",
});

const ENVIRONMENT_OPTIONS: RedoListItem<ChitChatsEnvironment>[] = [
  { id: "production", type: "text", text: "Production", value: "production" },
  { id: "staging", type: "text", text: "Staging", value: "staging" },
];

export const CreateChitChatsCarrierForm = memo(
  function CreateChitChatsCarrierForm({
    carrierInput,
  }: {
    carrierInput: ChitChatsCarrierForm;
  }) {
    return (
      <>
        <RedoTextInput
          label="Client ID"
          placeholder=""
          setValue={carrierInput.inputs.clientId.setValue}
          value={carrierInput.inputs.clientId.value}
        />
        <RedoTextInput
          label="API token"
          placeholder=""
          setValue={carrierInput.inputs.apiToken.setValue}
          value={carrierInput.inputs.apiToken.value}
        />
        <RedoSingleSelectDropdownInput
          label="Environment"
          options={ENVIRONMENT_OPTIONS}
          optionSelected={({ item }) => {
            carrierInput.inputs.environment.setValue(item.value);
          }}
          selectedItem={ENVIRONMENT_OPTIONS.find(
            (option) => option.value === carrierInput.inputs.environment.value,
          )}
        />
      </>
    );
  },
);
